import { DateTime } from "luxon";
import { Clock2 } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import "./App.css";
import Fields from "./components/Fields";

const workatoWebhook = "https://webhooks.workato.com/webhooks/rest";

function Research() {
  const clientId = uuidv4();
  const [message, setMessage] = useState("");
  const [alertShown, setAlertShown] = useState(false);
  const [onTesting, setOnTesting] = useState(false); // Change true for testing
  const [loadTime, setLoadTime] = useState("");
  const [unix, setUnix] = useState("");

  const teste = useCallback(() => {
    const fieldsTemplates = {
      pipefy_token: "",
      fields: [
        {
          title: "Texto Editavel",
          editable: true,
          message: "",
          type: "text",
          limit: 4,
          placeholder: "31,00",
        },
        {
          message: `
  --- 
  <div style="text-align: center;">

  # Titulo teste
  ## Subtitulo teste
  - **Mensagem de teste** para um titulo editável com link, 

  </div> <br>

  ### Usando Markdown:
  -> clique [aqui](https://www.google.com/) para ser redirecionado a pagina do google

  ### Usando HTML:
  -> clique <a href="https://www.exemplo.com/" target="_blank" rel="noopener noreferrer" style="font-weight: normal;">aqui</a>
  para ser redirecionado a pagina do google

  ### teste checkbox:
  - [x] Feito ✅
  - [ ] Não feito

  ---
        `,
          type: "dynamic-text",
        },
        {
          title: "Texto Editavel",
          editable: true,
          message: "teste",
          type: "text",
        },
        {
          title: "Select Editavel",
          editable: true,
          value: "teste3",
          items: ["teste1", "teste2", "teste3"],
          table_id: "",
          type: "select",
        },
        {
          title: "Checkbox Editavel 2 items",
          editable: true,
          checked: ["teste1", "teste2"],
          items: ["teste1", "teste2"],
          table_id: "",
          type: "checkbox",
        },
        {
          title: "Checkbox Editavel 1 item",
          editable: true,
          checked: [],
          items: ["teste1"],
          table_id: "",
          type: "checkbox",
        },
        {
          title: "Radio Editavel",
          editable: true,
          value: "ativo",
          items: ["ativo", "desativo"],
          table_id: "",
          type: "radio",
        },
        {
          title: "Texto Não Editavel",
          editable: false,
          message: "teste",
          type: "text",
        },
        {
          title: "Select Não Editavel",
          editable: false,
          value: "teste2",
          items: ["teste1", "teste2", "teste3"],
          table_id: "",
          type: "select",
        },
        {
          title: "Checkbox Não Editavel",
          editable: false,
          checked: ["teste1", "teste2"],
          items: ["teste1", "teste2"],
          table_id: "",
          type: "checkbox",
        },
        {
          title: "Radio Não Editavel",
          editable: false,
          value: "teste1",
          items: ["teste1", "teste2"],
          table_id: "",
          type: "radio",
        },
      ],
    };

    setTimeout(() => {
      if (fieldsTemplates.popup) {
        alert(fieldsTemplates.popup);
      } else {
        alert("Busca concluída!");
      }
      console.log(fieldsTemplates);
      setMessage(fieldsTemplates);
      setAlertShown(true);
      setOnTesting(false);
    }, 5000);
  }, []);

  useEffect(() => {
    if (onTesting) teste();
  }, [onTesting, teste]);

  useEffect(() => {
    const fieldInfo = document.getElementById(
      "element-startform-2816cb73-280f-4c5e-b79f-b8bfd7e718a4-Select-1d5eaf50-319b-4657-b6a8-09fe3521ae1f"
    );

    setLoadTime(() => DateTime.now().toFormat("yyyy-MM-dd'T'HH:mm:ss.SSSZZ"));
    setUnix(() => Date.now());

    console.log(fieldInfo ?? "fieldInfo -- Valor indisponível");
    console.log(
      fieldInfo && fieldInfo.value !== null
        ? fieldInfo.value
        : "fieldInfo.value --- Valor indisponível"
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const socket = new WebSocket(process.env.REACT_APP_WS_HOST);

    socket.onopen = () => {
      console.log("Connected to websocket");
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.clientId === clientId && !alertShown) {
          if (data.popup) {
            alert(data.popup);
          } else {
            alert("Busca concluída!");
          }
          console.log(data);
          setMessage(data);
          setAlertShown(true);
        }
      } catch (error) {
        console.error("Error when processing message", error);
      }
    };

    socket.onerror = (error) => {
      console.error("Error in WebSocket:", error);
    };

    socket.onclose = () => {
      console.log("Websocket connection closed.");
    };

    const timeoutId = setTimeout(() => {
      const reactUrl = new URL(window.location.href);
      const params = new URLSearchParams(reactUrl.search);

      const WorkatoRecipeId = params.get("recipeP1");
      const WorkatoRecipeName = params.get("recipeP2");

      const time = new Date();
      const hours = `${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;

      const urlWorkato = new URL(
        `${workatoWebhook}/${WorkatoRecipeId}/${WorkatoRecipeName}`
      );

      urlWorkato.searchParams.append("clientId", `${clientId}`);
      urlWorkato.searchParams.append("time0", `${loadTime}`);
      urlWorkato.searchParams.append("time", `${hours}`);
      urlWorkato.searchParams.append("unix", `${unix}`);

      const img = new Image();
      img.src = urlWorkato.href;
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [alertShown, clientId, loadTime, unix]);

  const sendUpdatedMessage = (event, label) => {
    if (message?.recipe?.p1 && message?.recipe?.p1 && message?.clientId) {
      const returnRecipe = new URL(
        `${workatoWebhook}/${message.recipe.p1}/${message.recipe.p2}`
      );

      returnRecipe.searchParams.append("clientId", `${message.clientId}`);
      returnRecipe.searchParams.append("label", `${label}`);
      returnRecipe.searchParams.append("newMessage", `${event.target.value}`);

      const img = new Image();
      img.src = returnRecipe.href;
    }
  };

  return (
    <div
      className="App-header"
      style={{ "background-color": "red", color: "#101820", opacity: 100 }}
    >
      {message ? (
        message.fields.map((field, index) => (
          <div key={index} className="container-label-input">
            <p className="label" style={{ marginBottom: 0 }}>
              {field.title}
            </p>
            <Fields
              field={field}
              onChange={sendUpdatedMessage}
              pipefy_token={message.pipefy_token ?? ""}
            />
          </div>
        ))
      ) : (
        <div className="information-container">
          <div className="information-icon-container">
            <Clock2 className="information-icon" />
          </div>
          Realizando busca ...
        </div>
      )}
    </div>
  );
}

export default Research;
